import React, {PropTypes} from 'react';

const Button = ({
  onClick,
  value,
  disabled,
  className,
  name,
  id,
  title
}) => {
  return (
    <button
      id={id}
      value={value}
      disabled={disabled}
      className={"btn btn-primary " + className}
      onClick={onClick}
      name={name}
      title={title}>
      {value}
    </button>
  );
};

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string
};

export default Button;



/** WEBPACK FOOTER **
 ** ./src/components/common/Button.js
 **/